import { CloseIcon, GoIcon } from "@/components/icons";
import {
  Flex,
  Image,
  Text,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  useDisclosure,
  Box,
} from "@chakra-ui/react";
import CopyIcon from "@/assets/copy.png";
import { LogsButton } from "@/components/Button";
import { useUserInfo } from "@/context/UserInfo";
import { shortenAddress } from "@/utils";
import capsule from "@/constants/capsule";
import { useNavigate } from "react-router-dom";
import { avatarImg } from "@/utils/avatars";
import { formatAmountWithFixed } from "@/utils/formatBalance";
import { usdcInfo } from "@/constants/tokens";
import TitleHeader from "@/components/TitleHeader";
import { useClipboard } from "@chakra-ui/react";
import { useCurrencyExchange } from "@/hooks/useCurrencyExchange";
import SetIcon from "./assets/set.png";
import OutIcon from "./assets/out.png";
import PKeyIcon from "./assets/pkey.png";
import WithdrawIcon from "./assets/withdraw.png";
import { CapsuleModal, ModalStep } from "@usecapsule/react-sdk";
import { useState } from "react";
import AddIcon from "./assets/icon-edit.png";
import EditIcon from "./assets/icon-edit.png";
import KycStatus from "./KycStatus";

const MyOrg = () => {
  const [isWalletBackupOpen, setIsWalletBackupOpen] = useState(false);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { orgName, senderAddress, avatarIndex, usdcBalance } = useUserInfo();
  const { onCopy, value, setValue, hasCopied } = useClipboard(senderAddress);
  const { currencyUnit, usdToCurrency } = useCurrencyExchange();

  const navigate = useNavigate();

  const handleToSetting = () => {
    navigate("/setting");
  };

  const handleToWithdraw = () => {
    navigate("/withdraw");
  };

  const handleToPKey = () => {
    navigate("/pkey");
  };

  const handleLogout = async () => {
    await capsule.logout();
    localStorage.removeItem("isLogin");
    navigate("/login");
  };

  return (
    <Box
      sx={{
        padding: "20px",
        height: "100%",
        position: "relative",
        overflow: "auto",
      }}
    >
      <TitleHeader
        color="#D8762B"
        title="My Account"
        onBack={() => navigate("/")}
        showSwitch={true}
      />

      <Flex
        sx={{
          width: "100%",
          background: "#D8762B",
          position: "relative",
          height: "220px",
          marginTop: "56px",
          borderRadius: "20px",
          paddingTop: "40px",
        }}
        flexDir={"column"}
        align={"center"}
      >
        <Flex
          sx={{
            height: "60px",
            width: "60px",
            borderRadius: "50%",
            background: "#fff",
            fontSize: "40px",
            position: "absolute",
            top: "0",
            left: "50%",
            transform: "translate(-50%,-50%)",
          }}
          align={"center"}
          justify={"center"}
          onClick={() => {
            navigate("/editAvatar");
          }}
        >
          <Text sx={{}}>{avatarImg(avatarIndex)}</Text>
          <Image
            src={AddIcon}
            sx={{
              width: "28px",
              cursor: "pointer",
              height: "28px",
              position: "absolute",
              bottom: "-10px",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          ></Image>
        </Flex>

        <Flex
          align={"center"}
          sx={{
            marginTop: "2px",
          }}
        >
          <Text
            sx={{
              color: "#FFF",
              textAlign: "center",
              fontSize: "16px",
              fontWeight: 500,
              marginRight: "4px",
            }}
          >
            {orgName ? orgName : "Unnamed"}
          </Text>
          {!orgName && (
            <Image
              onClick={() => {
                navigate("/setOrgName");
              }}
              src={EditIcon}
              sx={{
                width: "18px",
                cursor: "pointer",
              }}
            ></Image>
          )}
        </Flex>

        <Flex
          align={"center"}
          sx={{
            marginTop: "8px",
            cursor: "pointer",
          }}
          onClick={() => {
            onCopy();
          }}
        >
          <Text
            sx={{
              color: "#FFF",
              fontSize: "14px",
              marginRight: "2px",
            }}
          >
            {shortenAddress(senderAddress)}
          </Text>
          <Image
            src={CopyIcon}
            sx={{
              width: "12px",
            }}
          ></Image>
        </Flex>
        <Box sx={{ marginTop: "5px" }}>
          <KycStatus></KycStatus>
        </Box>
        <Text
          sx={{
            color: "#FFD096",
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 900,
            marginTop: "12px",
          }}
        >
          Balance:
        </Text>
        <Text
          sx={{
            fontSize: "50px",
            fontWeight: 900,
            marginTop: "2px",
            color: "#FFF",
            position: "relative",
          }}
        >
          {formatAmountWithFixed(usdToCurrency(usdcBalance), usdcInfo.decimals)}{" "}
          <span
            style={{
              fontSize: "20px",
              fontWeight: 900,
              color: "#FFF",
            }}
          >
            {currencyUnit}
          </span>
        </Text>
        {currencyUnit !== "USD" && (
          <Text
            sx={{
              fontSize: "20px",
              fontStyle: "normal",
              fontWeight: 700,
              color: "#FFF",
              marginTop: "2px",
            }}
          >
            {formatAmountWithFixed(usdcBalance, usdcInfo.decimals)} USDC
          </Text>
        )}
      </Flex>

      <LogsButton
        sx={{
          marginTop: "10px",
          padding: "0 30px",
          justifyContent: "flex-start",
          width: "100%",
        }}
        onClick={handleToWithdraw}
      >
        <Image
          src={WithdrawIcon}
          sx={{
            width: "14px",
          }}
        ></Image>
        <Text
          sx={{
            color: "#FFF",
            fontSize: "16px",
            fontWeight: 500,
            marginLeft: "8px",
          }}
        >
          Withdraw
        </Text>
        <GoIcon
          style={{
            marginLeft: "auto",
          }}
        ></GoIcon>
      </LogsButton>
      <Box sx={{ borderBottom: "1px dashed #D8762B", margin: "20px 0" }}></Box>
      <LogsButton
        sx={{
          padding: "0 30px",
          justifyContent: "flex-start",
          width: "100%",
        }}
        onClick={handleToSetting}
      >
        <Image
          src={SetIcon}
          sx={{
            width: "14px",
            height: "14px",
          }}
        ></Image>
        <Text
          sx={{
            color: "#FFF",
            fontSize: "16px",
            fontWeight: 500,
            marginLeft: "8px",
          }}
        >
          Setting
        </Text>
        <GoIcon
          style={{
            marginLeft: "auto",
          }}
        ></GoIcon>
      </LogsButton>
      <Box sx={{ borderBottom: "1px dashed #D8762B", margin: "20px 0" }}></Box>
      <LogsButton
        sx={{
          padding: "0 30px",
          justifyContent: "flex-start",
          width: "100%",
        }}
        onClick={() => {
          setIsWalletBackupOpen(true);
        }}
      >
        <Image
          src={PKeyIcon}
          sx={{
            width: "14px",
            height: "14px",
          }}
        ></Image>
        <Text
          sx={{
            color: "#FFF",
            fontSize: "16px",
            fontWeight: 500,
            marginLeft: "8px",
          }}
        >
          Wallet backup
        </Text>
        <GoIcon
          style={{
            marginLeft: "auto",
            color: "#fff",
          }}
        ></GoIcon>
      </LogsButton>

      <LogsButton
        onClick={onOpen}
        variant="outlined"
        sx={{
          marginTop: "10px",
          padding: "0 30px",
          justifyContent: "flex-start",
          width: "100%",
        }}
      >
        <Image
          src={OutIcon}
          sx={{
            width: "14px",
          }}
        ></Image>
        <Text
          sx={{
            fontSize: "16px",
            marginLeft: "8px",
            color: "#D8762B",
          }}
        >
          Log out
        </Text>
        <GoIcon
          style={{
            marginLeft: "auto",
            color: "#D8762B",
          }}
        ></GoIcon>
      </LogsButton>
      <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent
          sx={{
            padding: "30px 20px",
            background: "#fff",
            borderRadius: "20px 20px 0 0",
          }}
        >
          <DrawerBody
            sx={{
              padding: "0",
            }}
          >
            <CloseIcon
              onClick={onClose}
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                width: "16px",
                height: "16px",
                cursor: "pointer",
                color: "#333",
              }}
            ></CloseIcon>

            <Flex
              flexDir={"column"}
              align={"center"}
              sx={{
                background: "#fff",
                borderRadius: "32px",
                paddingTop: "8px",
              }}
            >
              <Text
                sx={{
                  color: "#333",
                  textAlign: "center",
                  fontSize: "24px",
                  fontWeight: 700,
                }}
              >
                Confirm to log out?
              </Text>
              <LogsButton
                onClick={handleLogout}
                sx={{
                  marginTop: "25px",
                }}
              >
                Log out
              </LogsButton>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <CapsuleModal
        currentStepOverride={ModalStep.SECRET}
        onModalStepChange={() => {
          console.log("onModalStepChange");
        }}
        capsule={capsule}
        isOpen={isWalletBackupOpen}
        onClose={() => {
          setIsWalletBackupOpen(false);
        }}
      />
    </Box>
  );
};

export default MyOrg;
